import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import { ContentProvider } from "./lib/content";
import { captureRefFromUrl } from "./lib/referral";

function RefCapture() {
  const loc = useLocation();
  useEffect(() => { captureRefFromUrl(); }, [loc.search]);
  return null;
}

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Tables from "./pages/Tables";
import Carpool from "./pages/Carpool";
import Affiliation from "./pages/Affiliation";
import Gallery from "./pages/Gallery";
import FolderView from "./pages/FolderView";
import Earnings from "./pages/Earnings";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import { Login, Register } from "./pages/Auth";

export default function App() {
  return (
    <AuthProvider>
      <ContentProvider>
      <BrowserRouter>
        <RefCapture/>
        <div className="min-h-screen flex flex-col bg-black">
          <Navbar/>
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home/>}/>
              <Route path="/tavoli" element={<Tables/>}/>
              <Route path="/carpooling" element={<Carpool/>}/>
              <Route path="/affiliazione" element={<Affiliation/>}/>
              <Route path="/gallery" element={<Gallery/>}/>
              <Route path="/gallery/:id" element={<FolderView/>}/>
              <Route path="/incassi" element={<Earnings/>}/>
              <Route path="/contatti" element={<Contact/>}/>
              <Route path="/admin" element={<Admin/>}/>
              <Route path="/login" element={<Login/>}/>
              <Route path="/register" element={<Register/>}/>
            </Routes>
          </main>
          <Footer/>
        </div>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0A0A0A",
              border: "1px solid #262626",
              color: "#F5F5F5",
              borderRadius: 0,
              fontFamily: "JetBrains Mono, monospace",
              fontSize: 12
            }
          }}
        />
      </BrowserRouter>
      </ContentProvider>
    </AuthProvider>
  );
}
